import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import IntakeWitnessDefendantStatementDetailsFields from '../../../components/intake/witness-defendant-statement/details-fields';
import FormFooter from '../../../components/form-footer';
import { selectActiveFormWitnessDefendantStatementDetails, updateWitnessDefendantStatementDetails } from '../../../reducers/active-form-slice';
import WitnessDefendantStatementDetailsSchema from '../../../validation-schemas/witness-defendant-statement-details';
import FormHeaderButtons from '../form-header-buttons';
import { hasNonBlankValues } from '../../../utility/has-values';


const IntakeWitnessDefendantStatementDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    /**
     * get current form values
     */
    const witnessDefendantStatementDetails = useSelector(selectActiveFormWitnessDefendantStatementDetails);
    const hasValues = hasNonBlankValues(witnessDefendantStatementDetails);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/");
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateWitnessDefendantStatementDetails(values));

        switch (values.statementType) {
            case "Defendant":
            case "Both":
                navigate("/intake/witness-defendant-statement/defendant-info");
                break;
            case "Witness":
            default:
                navigate("/intake/witness-defendant-statement/witness-info");
                break;
        }
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateWitnessDefendantStatementDetails(values));
    };


    /**
     * setup the initial values
     */
    const initialValues = {
        dateOfLoss: '',
        timeOfLoss: '',
        locationOfLoss: '',
        factsOfLoss: '',
        specificQuestions: '',
        directionOfTravel: '',
        streetOfTravel: '',
        vehicleDescription: '',
        pedestrianIdentifiers: '',
        statementType: '',
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? witnessDefendantStatementDetails : initialValues}
                validationSchema={WitnessDefendantStatementDetailsSchema.fields.witnessDefendantStatementDetails}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Witness OR Defendant Statement Details</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>
                
                        <IntakeWitnessDefendantStatementDetailsFields
                            errors={errors}
                            touched={touched}
                            values={values}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`25`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeWitnessDefendantStatementDetails;